import WhatsappIcon from '../../img/whatsapp-svgrepo-com 1.svg';
import {
    WHATS_APP_LINK,
    PPA_ADMIN_PHONE_NUMBER,
    ADMIN_WHATSAPP_MESSAGE,
} from "../../Constants/LandingPageConstants";

const WhatsappContactUs = () => {
  return (
    <a onClick={() => window.open(WHATS_APP_LINK + PPA_ADMIN_PHONE_NUMBER + ADMIN_WHATSAPP_MESSAGE, "_blank")} className='fixed bottom-4 right-4 z-50 w-fit bg-[#50cc5d] rounded-3xl py-2 px-3 sm:py-3 sm:px-4 text-white flex items-center gap-3 cursor-pointer'>
      <img src={WhatsappIcon} alt='whats app' width={30} height={30} />
      <div className='text-[16px] leading-6'>Talk to us</div>
    </a>
  )
}

export default WhatsappContactUs;
